import React, { useState, useEffect } from 'react'
import success_img from '../assets/success.png'
export default function AutoBack(props) {
    const [timerID, setTimerID] = useState(null)
    const [counter, setCounter] = useState(3)
    useEffect(() => {
        if(counter > 0){
            console.log(counter)
            let timer = setTimeout(() => {
                setCounter(counter - 1)
            }, 2000)
            setTimerID(timer)
        } else {
            props.props.history.push(`/Login${props.props.location.search}`)
        }
        
        return () => {
            setTimerID(null)
        }
    }, [counter])
     
    return (
        <div>
            <div style={{textAlign:"center",marginTop:100}}>
                <img src={success_img}/>
                <p style={{fontSize:16,fontWeight:"bold",color:'#666666',marginTop:10}}>密码设置成功</p>
                <div style={{color:'#BABABA',fontSize1:14,marginTop:50}}>即将进入系统....</div>
            </div>

        </div>


        // <h3 id='tip'>{counter}秒后系统将自动跳转到登录页面...</h3>
    )
}
